import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as UserActions from 'app/modules/user/actions'
import { patchOperations } from 'utils/PatchHelper'
import { AvailabilityStatus } from 'components/shared/AgentStatusAvatar/constants'
import Toggle from 'components/Toggle'
import PropTypes from 'prop-types'
import UserHeader from '../UserHeader'
import './style'
import UserPermission from './UserPermission'
import * as TeamConstants from '../TeamConstants'
import DriftSelect from 'components/shared/UISelect'
import withNotifications from 'components/shared/notifications'
import { Icon, Button, Loader } from '@driftt/tide-core-legacy'
import { fetchTeamsForUser } from 'app/modules/teams/actions'
import { teamsForUser } from 'app/modules/teams/selectors'
import VariedPermissionsSection from '../TeamTable/VariedPermissionsSection'
import { all } from 'ramda'
import Access from 'utils/Access'
import { makeHasGate } from 'app/modules/gates/selectors'
import IndividualConversationLimit from '../IndividualConversationLimit'
import { hasCalendarScope } from '../InviteHelpers'

const OWNER_ROLE = 'OWNER'

class EditUserRole extends Component {

  static contextTypes = {
    app: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)

    const firstUser = props.users[0]
    const isMultiUser = props.users.length > 1
    const initialScopes = props.initialScopes || []
    const availabilityStatus = all(user => user.availability !== 'OFFLINE')(props.users)

    this.state = {
      availabilityStatus,
      isBulkEditingWithOwner: this.bulkEditContainsOwner(),
      isMultiUser: isMultiUser,
      isLoadingTeams: false,
      hasPremiumDrift: props.hasPremiumDrift,
      adminChecked: !isMultiUser && initialScopes.includes(TeamConstants.permissionScopes.ADMIN),
      userChecked: !isMultiUser && initialScopes.includes(TeamConstants.permissionScopes.NON_ADMIN),
      selectedChatPermission: initialScopes.find(scope => scope.includes('convo')) || TeamConstants.conversationScopes.ALL
    }
  }

  componentDidMount() {
    const { isMultiUser } = this.state
    const { users, actions } = this.props
    
    if (!isMultiUser && !!users[0].id) {
      actions.fetchTeamsForUser({ userId: users[0].id })
      this.setState({ isLoadingTeams: true })
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userTeams !== this.props.userTeams) {
      this.setState({ isLoadingTeams: false })
    }
  }

  bulkEditContainsOwner = () => {
    const { users } = this.props

    const userRoles = users.map(x => x.role)
    return users.length > 1 && userRoles.includes(OWNER_ROLE)
  }

  updateAvailabilityStatus = (event) => {
    const status = event.target.checked ? AvailabilityStatus.ACTIVE : AvailabilityStatus.AWAY
    const singleUser = this.props.users.length === 1

    const operations = patchOperations(
      { availability: status }
    )

    this.setState({ availabilityStatus: !!event.target.checked })
    _.each(this.props.users, user => {
      this.props.actions.updateOrgUserStatus(user.id, operations)
    })

    this.props.notifications.success(`Successfully set ${singleUser
      ? this.props.users[0].name || this.props.users[0].email
      : `${this.props.users.length} users`
    } to ${status.toLowerCase()}`)
  }

  onNext = () => {
    const selectedScopes = [TeamConstants.requiredScopes.MEMBER]

    if (this.state.hasPremiumDrift) {
      if (this.state.adminChecked) {
        selectedScopes.push(TeamConstants.permissionScopes.ADMIN)
      } else {
        selectedScopes.push(TeamConstants.permissionScopes.NON_ADMIN)
        selectedScopes.push(this.state.selectedChatPermission || TeamConstants.conversationScopes.ALL)
      }
    } else {
      selectedScopes.push(TeamConstants.permissionScopes.ADMIN)
    }

    this.props.onNext(selectedScopes, this.props.users)
  }

  adminPermissionChanged = event => {
    this.setState({
      adminChecked: !!event.target.checked,
      userChecked: false
    })
  }

  userPermissionChanged = event => {
    this.setState({
      adminChecked: false,
      userChecked: !!event.target.checked
    })
  }

  chatPermissionChanged = event => {
    this.setState({
    selectedChatPermission: event.value
  })
  }

  renderUserTeams = () => {
    const { isLoadingTeams } = this.state
    const { userTeams } = this.props

    const teamNames = [...new Set(userTeams.map(team => team.name))].join(', ')


    return (
      <div className="edit-user-members-teams">
        <span className="scope-detail-name">Teams</span>
        { isLoadingTeams &&
          <Loader/>
        }
        { !isLoadingTeams && !!userTeams.length &&
          <p>{teamNames}</p>
        }
        { !isLoadingTeams && !userTeams.length &&
          <p>None</p>
        }
      </div>
    )
  }

  get hasCalendarUsers() {
    return this.props.users.some(hasCalendarScope)
  }

  get isDisabled() {
    const { permissionsAreDisabled, isBulkEditingWithOwner } = this.state
    return this.hasCalendarUsers || permissionsAreDisabled || isBulkEditingWithOwner
  }

  render() {
    const { users, onClose, nextCopy, cancelCopy, modalView, className, showStatus, pricingMessage, warning, permissionsAreDisabled, hasIndividualConversationLimit, showAccountOwnerTransfer } = this.props
    const { availabilityStatus, adminChecked, userChecked, hasPremiumDrift, selectedChatPermission, isMultiUser, isBulkEditingWithOwner } = this.state

    return (
      <div className={className}>
        <header className="edit-team-members-header">
          {modalView && (
            <div onClick={onClose}>
              <Icon name="close" className="close-button" />
            </div>
          )}
          <UserHeader showAccountOwnerTransfer={showAccountOwnerTransfer} users={users} leaveSpaceOnTheRight={showStatus} />

          {showStatus && <section className="user-availability-edit">
            <span className="user-availability-edit-status">Status: {availabilityStatus ? 'Active' : 'Away'}</span>
            <Toggle
              className="user-avilability-toggle"
              onChange={this.updateAvailabilityStatus}
              defaultChecked={availabilityStatus}
            />
          </section>
          }
        </header>

        <section className="user-permissions-section">
          <ul className="user-permission-options">
            {hasPremiumDrift && (
              <UserPermission
                name="Chat User"
                description="Users can only access certain conversations, their own settings and a limited view of Playbooks and Contacts."
                onChange={this.userPermissionChanged}
                defaultChecked={userChecked}
                disabled={permissionsAreDisabled}>
                <DriftSelect
                  searchable={false}
                  onSelection={this.chatPermissionChanged}
                  value={adminChecked ? TeamConstants.conversationScopes.ALL : selectedChatPermission}
                  disabled={adminChecked || permissionsAreDisabled}
                  options={[
                    { label: 'They can see all conversations', value: TeamConstants.conversationScopes.ALL },
                    { label: 'They can see their conversations, and ones with no participants', value: TeamConstants.conversationScopes.NO_PARTICIPANTS },
                    { label: 'They can see their conversations only', value: TeamConstants.conversationScopes.ONLY_MINE }
                  ]}
                />
              </UserPermission>
            )}
            {this.hasCalendarUsers &&
              <UserPermission
                name="Calendar User"
                description="Calendar Users can only acces Drift Meetings and their meeting conversations (read only)"
                defaultChecked={false}
                disabled={true}
              />
            }
            {hasPremiumDrift && (
              <UserPermission
                name="Admin"
                description="Administrators can access everything in Drift, including all playbooks, team settings and billing."
                onChange={this.adminPermissionChanged}
                defaultChecked={adminChecked}
                disabled={permissionsAreDisabled}
              />
            )}
            {hasPremiumDrift && !isMultiUser && Access.hasGates('has_beta_team_view') && this.renderUserTeams()}
            {hasIndividualConversationLimit && <IndividualConversationLimit user={users[0]} />}
            {isBulkEditingWithOwner && <VariedPermissionsSection/>}
          </ul>
        </section>

        {pricingMessage &&
          <section className="user-money-warning">
            <p>{pricingMessage}</p>
          </section>
        }
        {this.hasCalendarUsers && !isBulkEditingWithOwner &&
          <p className="warning-section warning-section-calendar-user">
            <strong>You can’t edit permissions for Calendar Users at this time.</strong>
            Need some help? Chat with us
          </p>
        }

        {warning}

        <footer className="team-edit-modal-footer">
          <Button
            type="tertiary"
            onClick={onClose}>
            {cancelCopy}
          </Button>
          <Button
            name="primary"
            disabled={this.isDisabled}
            onClick={this.onNext}>
            {nextCopy}
          </Button>
        </footer>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  userTeams: teamsForUser(props.users[0].id)(state),
  hasIndividualConversationLimit: makeHasGate('single_user_convo_limit_gate')(state),
})


const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
    updateOrgUserStatus: UserActions.updateOrgUserStatus,
    fetchTeamsForUser
  }, dispatch)
})

const EditUserRoleNotifications = withNotifications(EditUserRole)
export default connect(mapStateToProps, mapDispatchToProps)(EditUserRoleNotifications)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/team/EditUserRole/index.js